import { Controller } from '@hotwired/stimulus';
import axios from "axios";

export default class extends Controller {
    connect() {
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];
        this.element.addEventListener('input', async (e) => {
            e.preventDefault();

            if (this.element.classList.contains('loading')) {
                return;
            }
            // eslint-disable-next-line no-negated-condition
            if (this.element.value !== '') {
                this.element.classList.add('not-empty');
            } else {
                this.element.classList.remove('not-empty');
            }
            this.element.classList.add('loading');

            const url = `/wp-json/api/${this.element.dataset.autocompleteUrlValue
            }?search=${this.element.value.toString()
            }&rest_language=${this.currentLanguageCode}`;
            // eslint-disable-next-line init-declarations
            let response;

            try {
                response = await axios.post(url, {}, { headers: { 'Content-Type': 'multipart/form-data' } });

                response = response.data.data;
            } catch (error) {
                response = error.response.data.data;
            }

            this.removeAutoCompletes();

            if (response && response.autocompletes && response.autocompletes.length) {
                this.setupFormGeneralSuccess(response.autocompletes);
            }
        });

        for (const searchBtn of document.getElementsByClassName('header__search-submit')) {
            searchBtn.addEventListener('click', (e) => {
                e.preventDefault();
                document.getElementById('header__search-input').value = '';
                document.getElementById('header__search-input').dispatchEvent(new Event('input'));
            });
        }
    }

    setupFormGeneralSuccess(autocompletes) {
        const autocompleteNode = document.createElement('ul');
        autocompleteNode.classList.add('search-autocomplete');

        autocompletes.forEach(function (autocomplete) {
            const listNode = document.createElement('li');
            const targetNode = document.createElement('a');
            targetNode.appendChild(document.createTextNode(autocomplete.title));
            targetNode.href = autocomplete.href;
            listNode.appendChild(targetNode);
            autocompleteNode.appendChild(listNode);
        });
        this.element.parentNode.insertBefore(autocompleteNode, this.element);
    }

    removeAutoCompletes() {
        const autoCompletes = this.element.parentNode.querySelectorAll('.search-autocomplete');

        for (const el of autoCompletes) {
            el.remove();
        }

        this.element.classList.remove('loading');
    }
}
